import React from 'react';
import { Grid, Button } from '@mui/material';
import {
  Backspace as BackspaceIcon,
  Check as CheckIcon,
} from '@mui/icons-material/';

function CalculatorItem({ value, updateAmount }) {
  return (
    <Grid
      item
      xs={3}
      sx={{
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid
        item
        sx={{
          height: '125px',
          width: '125px',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {value !== null &&
          value !== 'confirm' &&
          value !== 'confirmNewPincode' && (
            <Button
              variant="contained"
              component="label"
              sx={{
                height: '100%',
                width: '100%',
                fontSize: '35px',
                fontWeight: 'bold',
                background: value === 'backspace'
                  ? 'linear-gradient(160deg, #ff9ecf 0%, #e05fa3 100%)'
                  : 'linear-gradient(160deg, #9dafbd 0%, #6d8190 100%)',
                boxShadow: value === 'backspace'
                  ? '0 4px 12px rgba(252,134,193,0.2), inset 0 1px 0 rgba(255,255,255,0.14)'
                  : '0 4px 12px rgba(136,156,171,0.2), inset 0 1px 0 rgba(255,255,255,0.14)',
                borderRadius: '12px',
                transition: 'transform 80ms ease, box-shadow 80ms ease',
                '&:active': {
                  transform: 'translateY(3px)',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.1)',
                },
                color: 'white',
                marginTop: '15px',
              }}
              onClick={() => {
                updateAmount(value);
              }}
            >
              {value === 'backspace' ? <BackspaceIcon /> : value}
            </Button>
          )}

        {(value === 'confirm' || value === 'confirmNewPincode') && (
          <Button
            variant="contained"
            component="label"
            sx={{
              height: '100%',
              width: '100%',
              fontSize: '35px',
              fontWeight: 'bold',
              background: 'linear-gradient(160deg, #00c9a4 0%, #00806a 100%)',
              boxShadow:
                '0 4px 12px rgba(0,158,130,0.2), inset 0 1px 0 rgba(255,255,255,0.14)',
              borderRadius: '12px',
              transition: 'transform 80ms ease, box-shadow 80ms ease',
              '&:active': {
                transform: 'translateY(3px)',
                boxShadow:
                  '0 2px 6px rgba(0,158,130,0.18), inset 0 1px 0 rgba(255,255,255,0.1)',
              },
              color: 'white',
              marginTop: '15px',
            }}
            onClick={() => {
              updateAmount(value);
            }}
          >
            {value === 'confirm' || value === 'confirmNewPincode' ? (
              <CheckIcon />
            ) : (
              value
            )}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

export default CalculatorItem;
